import { GlobalStoreContextType } from "../../context/GlobalStoreContext";
import Permission from "../../Permission";
import TeamInfo from "../../teamInfo";

export const canManageMembersOnTeamPage = (team: TeamInfo, context: GlobalStoreContextType): boolean => {
    if (!team) {
        return false;
    }
    if (context.userHasPermission(Permission.is_admin, team.id, null)) {
        return true;
    }
    return false;
};

export const canManageMembers = (team: TeamInfo, context: GlobalStoreContextType, project: any) => {
    if (!team || !context.currentTeam) {
        return false;
    }

    const isOnTeamToAdmin = team?.id === context.currentTeam?.id;
    const isAdminOnCurrentTeam = context.userHasPermission(Permission.is_admin, team?.id, null);

    const isGCMember = project && context.currentTeam.id == project?.owning_team_id;
    const isGCLead = project && context.userHasPermission(Permission.is_lead, context.currentTeam?.id, project.id);
    const isGCAdmin = project && context.userHasPermission(Permission.is_admin, project?.owning_team_id, null);
    const isLeadership = isGCLead || isGCAdmin;

    return (isOnTeamToAdmin && isAdminOnCurrentTeam) || (project && isGCMember && isLeadership);
};

export const canEditTeamInfo = (team: TeamInfo, context: GlobalStoreContextType, isJobsite: boolean): boolean => {
    if (!isJobsite) {
        return false;
    }
    // User is an admin on the team.
    if (context.userHasPermission(Permission.is_admin, team?.id, null)) {
        return true;
    }
    // User has `is_admin` on the project's owning team. This exists because we
    // let GCs mangle the teams that are on their projects.
    if (context.userHasPermission(Permission.is_admin, context.currentProjectInfo.owning_team_id, null)) {
        return true;
    }
    // User is a lead for this project through the project's owning team. This
    // exists because we let GCs mangle the teams that are on their projects.
    if (
        context.userHasPermission(
            Permission.is_lead,
            context.currentProjectInfo.owning_team_id,
            context.currentProjectInfo.id
        )
    ) {
        return true;
    }

    return false;
};
